import { useMemo } from 'react';

const useMemoByKey = (effect, deps) => {
  return useMemo(effect, deps);
};

export default useMemoByKey;
